(function () {
  if (window.__jovelleeDiscountCode) return;
  window.__jovelleeDiscountCode = true;

  var STORAGE_KEY = 'jovellee-discount-code';
  var PAYMENT_SELECTOR = '.shopify-payment-button, shopify-accelerated-checkout, shopify-paypal-button, .ajax-cart__buttons-additional';

  function rootPath() {
    if (window.Shopify && Shopify.routes && Shopify.routes.root) return Shopify.routes.root;
    return '/';
  }

  function cartId(token) {
    return String(token || '').split('?')[0];
  }

  function sanitize(code) {
    return String(code || '').replace(/[^A-Za-z0-9_-]/g, '');
  }

  function readStore() {
    try {
      var raw = sessionStorage.getItem(STORAGE_KEY) || '';
      if (!raw) return null;
      if (raw.charAt(0) !== '{') return { code: sanitize(raw), token: '' };
      var parsed = JSON.parse(raw);
      return { code: sanitize(parsed && parsed.code), token: cartId(parsed && parsed.token) };
    } catch (error) {
      return null;
    }
  }

  function remember(code, token) {
    var id = cartId(token);
    if (!code || !id) return;
    try {
      sessionStorage.setItem(STORAGE_KEY, JSON.stringify({ code: code, token: id }));
    } catch (error) {}
  }

  function forget() {
    try {
      sessionStorage.removeItem(STORAGE_KEY);
    } catch (error) {}
  }

  function activeCode() {
    var stored = readStore();
    if (!stored || !stored.code || !stored.token) return '';
    return stored.code;
  }

  function copyText(text) {
    if (navigator.clipboard && window.isSecureContext) {
      return navigator.clipboard.writeText(text);
    }
    return new Promise(function (resolve, reject) {
      var input = document.createElement('textarea');
      input.value = text;
      input.setAttribute('readonly', '');
      input.style.position = 'fixed';
      input.style.left = '-9999px';
      document.body.appendChild(input);
      input.select();
      try {
        document.execCommand('copy') ? resolve() : reject(new Error('copy failed'));
      } catch (error) {
        reject(error);
      } finally {
        input.remove();
      }
    });
  }

  function getCart() {
    return fetch(rootPath() + 'cart.js', {
      credentials: 'same-origin',
      cache: 'no-store',
      headers: { Accept: 'application/json' }
    }).then(function (response) {
      if (!response.ok) throw new Error('cart failed');
      return response.json();
    });
  }

  function updateDiscount(code) {
    return fetch(rootPath() + 'cart/update.js', {
      method: 'POST',
      credentials: 'same-origin',
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json'
      },
      body: JSON.stringify({ discount: code })
    }).then(function (response) {
      if (!response.ok) throw new Error('cart discount failed');
      return response.json();
    });
  }

  function applyToCart(code) {
    return updateDiscount(code).then(function (cart) {
      remember(code, cart && cart.token);
      return cart;
    });
  }

  function removeStoredCode(cart, code) {
    var remaining = (cart.discount_codes || []).map(function (entry) {
      return entry && entry.code;
    }).filter(function (entry) {
      return entry && entry.toUpperCase() !== code.toUpperCase();
    });
    var hadCode = remaining.length !== (cart.discount_codes || []).length;
    if (!hadCode) return Promise.resolve(cart);
    return updateDiscount(remaining.join(','));
  }

  function syncStoredDiscount() {
    var stored = readStore();
    if (!stored || !stored.code) return Promise.resolve();
    return getCart().then(function (cart) {
      var current = cartId(cart && cart.token);
      if (!stored.token || !current || stored.token !== current) {
        forget();
        return removeStoredCode(cart, stored.code);
      }
      return applyToCart(stored.code);
    }).catch(function () {});
  }

  function markCopied(button) {
    var status = button.querySelector('.product-discount-code__status');
    button.classList.add('is-copied');
    if (status) status.textContent = 'Copied';
    window.setTimeout(function () {
      button.classList.remove('is-copied');
      if (status) status.textContent = '';
    }, 2000);
  }

  function isCheckoutPath(pathname) {
    return /\/checkouts?(\/|$)/.test(pathname || '');
  }

  document.addEventListener('click', function (event) {
    var button = event.target.closest('.product-discount-code');
    if (!button) return;
    event.preventDefault();
    var code = sanitize(button.getAttribute('data-discount-code'));
    if (!code || button.dataset.applying === 'true') return;
    button.dataset.applying = 'true';
    copyText(code).catch(function () {});
    applyToCart(code).catch(function () {}).finally(function () {
      button.dataset.applying = 'false';
      markCopied(button);
    });
  });

  document.addEventListener('click', function (event) {
    if (event.defaultPrevented || event.button !== 0) return;
    if (event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
    var link = event.target.closest && event.target.closest('a[href]');
    if (!link || link.dataset.jovelleeDiscountReady === 'true') return;
    if (!isCheckoutPath(link.pathname)) return;
    var code = activeCode();
    if (!code) return;
    event.preventDefault();
    link.dataset.jovelleeDiscountReady = 'true';
    applyToCart(code).catch(function () {}).finally(function () {
      window.location.href = link.href;
    });
  });

  document.addEventListener('submit', function (event) {
    var form = event.target;
    if (!(form instanceof HTMLFormElement) || form.dataset.jovelleeDiscountReady === 'true') return;
    var submitter = event.submitter;
    var checkoutSubmit = submitter ? submitter.name === 'checkout' : !!form.querySelector('[name="checkout"]');
    if (!checkoutSubmit) return;
    var code = activeCode();
    if (!code) return;
    event.preventDefault();
    form.dataset.jovelleeDiscountReady = 'true';
    applyToCart(code).catch(function () {}).finally(function () {
      if (typeof form.requestSubmit === 'function') form.requestSubmit(submitter || undefined);
      else form.submit();
    });
  }, true);

  function refreshForPayment(event) {
    var target = event.target;
    if (!(target instanceof Element)) return;
    if (!target.closest(PAYMENT_SELECTOR)) return;
    var code = activeCode();
    if (!code) return;
    applyToCart(code).catch(function () {});
  }

  document.addEventListener('pointerdown', refreshForPayment, true);

  if (window.fetch) {
    var originalFetch = window.fetch;
    window.fetch = function (input) {
      var requestUrl = typeof input === 'string' ? input : (input && input.url) || '';
      var result = originalFetch.apply(this, arguments);
      if (requestUrl.indexOf('/cart/add') !== -1) {
        result.then(function (response) {
          if (!response || !response.ok) return;
          if (!activeCode()) return;
          syncStoredDiscount();
        }).catch(function () {});
      }
      return result;
    };
  }

  syncStoredDiscount();

  window.addEventListener('pageshow', function (event) {
    if (!event.persisted) return;
    syncStoredDiscount();
  });
})();
